"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _style = _interopRequireDefault(require("../style.css"));
var _window$cccisd, _window$cccisd$env;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var Appdefs = window.cccisd.appDefs;
var recaptchaKey = (_window$cccisd = window.cccisd) === null || _window$cccisd === void 0 ? void 0 : (_window$cccisd$env = _window$cccisd.env) === null || _window$cccisd$env === void 0 ? void 0 : _window$cccisd$env.recaptchaKey;
var RegisterForm = function RegisterForm(props) {
  var showSuccessModal = function showSuccessModal() {
    var modalButton = document.getElementById('modalButton');
    if (modalButton) {
      modalButton.click();
    }
  };

  // Default is just to login after a successful register, but can be overridden with props
  // Note: If onRegisterSubmit is passed as prop, loginAfterRegister is not used
  var loginAfterRegister = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
      var _loginResponse$data, _loginResponse$data$d;
      var loginResponse, afterLoginUrl;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _cccisdAxios["default"].post(Boilerplate.route('api.nexus.login'), {
              username: values.username,
              password: values.password
            });
          case 2:
            loginResponse = _context.sent;
            if (!((_loginResponse$data = loginResponse.data) !== null && _loginResponse$data !== void 0 && (_loginResponse$data$d = _loginResponse$data.data) !== null && _loginResponse$data$d !== void 0 && _loginResponse$data$d.isMfa && typeof props.setMfaProps === 'function')) {
              _context.next = 6;
              break;
            }
            props.setMfaProps(_objectSpread(_objectSpread({}, loginResponse.data.data), {}, {
              loginResponse: loginResponse,
              redirectUrl: Fortress.settings.config.after_login_url
            }));
            return _context.abrupt("return");
          case 6:
            if (!(loginResponse.status !== 200)) {
              _context.next = 9;
              break;
            }
            (0, _cccisdNotification["default"])({
              message: 'Registration was successful, but you could not login at this time.',
              type: 'danger',
              duration: 5000
            });
            return _context.abrupt("return");
          case 9:
            if (loginResponse.data.notifications.length > 0) {
              loginResponse.data.notifications.forEach(function (note) {
                return (0, _cccisdNotification["default"])(note);
              });
            }
            if (loginResponse.data.status === 'success') {
              afterLoginUrl = Fortress.settings.config.after_login_url;
              if (loginResponse.data.data.hasIncompleteSiteRegistration) {
                window.location = Boilerplate.url("/account/registrationSurvey?redirectUrl=".concat(afterLoginUrl));
              } else {
                window.location = Boilerplate.url(afterLoginUrl);
              }
            } else if (loginResponse.data.status === 'error') {
              (0, _cccisdNotification["default"])({
                message: 'Registration was successful, but you could not login at this time.',
                type: 'danger',
                duration: 5000,
                data: loginResponse.data.errors
              });
            }
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function loginAfterRegister(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var defaultOnRegisterSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values) {
      var formValues, response, isErrorLocationInForm;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // Must copy values before manipulating or it will mutate Formik state object
            formValues = _objectSpread({}, values);
            formValues.role = props.role;
            formValues.group = props.group;
            formValues.username = formValues.username || formValues.email;
            _context2.next = 6;
            return _cccisdAxios["default"].post(Boilerplate.route('api.nexus.pawn.store'), formValues);
          case 6:
            response = _context2.sent;
            if (!(response.status !== 200)) {
              _context2.next = 10;
              break;
            }
            (0, _cccisdNotification["default"])({
              message: 'Could not register at this time.',
              type: 'danger',
              duration: 5000,
              data: response.data && response.data
            });
            return _context2.abrupt("return");
          case 10:
            if (!(response.data.status === 'success')) {
              _context2.next = 23;
              break;
            }
            if (!props.onRegisterSuccess) {
              _context2.next = 15;
              break;
            }
            props.onRegisterSuccess(formValues, response.data.data, props.setMfaProps);
            _context2.next = 21;
            break;
          case 15:
            if (!('password' in formValues && 'username' in formValues)) {
              _context2.next = 20;
              break;
            }
            _context2.next = 18;
            return loginAfterRegister(formValues);
          case 18:
            _context2.next = 21;
            break;
          case 20:
            showSuccessModal();
          case 21:
            _context2.next = 31;
            break;
          case 23:
            if (!(response.data.status === 'error')) {
              _context2.next = 31;
              break;
            }
            // If the email field is being used as username,
            // replace 'username' error with 'email' error
            if (!values.username && response.data.errors.username) {
              response.data.errors.email = response.data.errors.username;
              delete response.data.errors.username;
            }

            // errors may come back as something like {values: "Missing required middle name."},
            // so these will be displayed in a notification instead of styling in the form
            isErrorLocationInForm = !Object.keys(response.data.errors).find(function (errLocation) {
              return !(errLocation in values);
            }); // Throwing errors object will be picked up by formik, and style the incorrect input fields
            if (!isErrorLocationInForm) {
              _context2.next = 30;
              break;
            }
            throw response.data.errors;
          case 30:
            (0, _cccisdNotification["default"])({
              message: 'Failed to register',
              duration: 10000,
              type: 'danger',
              data: response.data.errors
            });
          case 31:
            if (response.data.notifications.length > 0) {
              response.data.notifications.forEach(function (note) {
                return (0, _cccisdNotification["default"])(note);
              });
            }
          case 32:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function defaultOnRegisterSubmit(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var validate = function validate(values) {
    var errors = {};
    if (!values.email) {
      errors.email = 'E-mail is required.';
    }
    if (props.hasSeparateUsername && !values.username) {
      errors.username = 'Username is required.';
    }
    if (props.showPasswordFields) {
      if (values.password !== values.repeatPassword) {
        errors.password = 'Passwords must match.';
        errors.repeatPassword = 'Passwords must match.';
      }
      if (!values.password) {
        errors.password = 'Password is required.';
      }
      if (!values.repeatPassword) {
        errors.repeatPassword = 'Must confirm password.';
      }
      if (!values.termsandconds) {
        errors.termsandconds = 'Must accept terms and conditions to continue.';
      }
    }
    if (props.isRecaptchaRequired && recaptchaKey && !values.recaptcha) {
      errors.recaptcha = 'Required';
    }
    values.selfRoster = true;
    if (props.validateAdditionalFields) {
      errors = _objectSpread(_objectSpread({}, errors), props.validateAdditionalFields(values));
    }
    return errors;
  };
  var topInstructions = props.topInstructions,
    bottomInstructions = props.bottomInstructions,
    renderAdditionalFields = props.renderAdditionalFields,
    showPasswordFields = props.showPasswordFields,
    hasSeparateUsername = props.hasSeparateUsername,
    emailLabel = props.emailLabel,
    initialValues = props.initialValues,
    renderAllFields = props.renderAllFields,
    isRecaptchaRequired = props.isRecaptchaRequired;

  // title, buttonText could come from Fortress config (legacy) or Appdefs (current)
  var title;
  if ('title' in props) {
    title = props.title;
  } else if ((0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.title', null)) {
    title = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.title');
  } else if ((0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.registerActionText', null)) {
    title = (0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.registerActionText');
  }
  var buttonText = 'Register';
  if (props.buttonText) {
    buttonText = props.buttonText;
  } else if ((0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.buttonText', null)) {
    buttonText = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.buttonText');
  } else if ((0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.registerActionText', null)) {
    buttonText = (0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.registerActionText');
  }
  var firstNameLabel = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.firstName', 'First Name:');
  var lastNameLabel = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.lastName', 'Last Name:');
  var emailUsernameLabel = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.email', emailLabel || (hasSeparateUsername ? 'Email:' : 'Email / Username:'));
  var usernameLabel = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.username', 'Username:');
  var passwordLabel = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.password', 'Password:');
  var confirmPasswordLabel = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.confirmPassword', 'Confirm Password:');
  var titleField = title && /*#__PURE__*/_react["default"].createElement("h4", {
    className: _style["default"].title
  }, title);
  var topInstructionsField = topInstructions && /*#__PURE__*/_react["default"].createElement("p", {
    className: _style["default"].topInstructions
  }, topInstructions);
  var firstNameField = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "first_name",
    component: _cccisdFormik.CccisdInput,
    label: firstNameLabel
  });
  var lastNameField = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "last_name",
    component: _cccisdFormik.CccisdInput,
    label: lastNameLabel
  });
  var emailField = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "email",
    autoComplete: "off" // stop the browser from autocompleting both the Register form and Login form
    ,
    component: _cccisdFormik.CccisdInput,
    label: emailUsernameLabel,
    type: "email"
  });
  var usernameField = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "username",
    component: _cccisdFormik.CccisdInput,
    label: usernameLabel
  });
  var passwordField = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "password",
    autoComplete: "new-password" // stop the browser from autocompleting both the Register form and Login form
    ,
    component: _cccisdFormik.CccisdPasswordInput,
    showPasswordToggle: true,
    label: passwordLabel
  });
  var repeatPasswordField = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "repeatPassword",
    autoComplete: "new-password" // stop the browser from autocompleting both the Register form and Login form
    ,
    component: _cccisdFormik.CccisdPasswordInput,
    showPasswordToggle: true,
    label: confirmPasswordLabel
  });
  var termsAndConditionsField = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "termsandconds",
    label: "I accept the privacy policy and terms of use.",
    component: _cccisdFormik.CccisdCheckboxInput,
    labelNotBold: true
  });
  var submitButton = function submitButton(formikProps) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      onClick: formikProps.handleSubmit,
      title: buttonText,
      className: "btn btn-primary ".concat(_style["default"].submitButton),
      isLoading: formikProps.isSubmitting
    });
  };
  var termsAndConditionsLinks = /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].termsAndCondsLinks
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.3cisd.com/privacy-policy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Privacy Policy"), /*#__PURE__*/_react["default"].createElement("a", {
    href: "http://www.3cisd.com/terms-of-use",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Terms of Use"));
  var bottomInstructionsField = /*#__PURE__*/_react["default"].createElement("p", {
    className: _style["default"].bottomInstructions
  }, bottomInstructions);
  var recaptchaField = recaptchaKey && isRecaptchaRequired && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "recaptcha"
  }, function (fieldProps) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, fieldProps, /*#__PURE__*/_react["default"].createElement(_reactGoogleRecaptcha["default"], {
      sitekey: recaptchaKey,
      onChange: function onChange(val) {
        return fieldProps.form.setFieldValue('recaptcha', val);
      }
    }));
  });
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    onSubmit: props.onRegisterSubmit || defaultOnRegisterSubmit,
    validate: validate,
    initialValues: _objectSpread({
      termsandconds: false
    }, initialValues),
    enableReinitialize: true
  }, function (formikProps) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, {
      className: _style["default"].form,
      autoComplete: "off"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        id: "modalButton",
        style: {
          display: 'none'
        }
      }, "click me"),
      title: "Success!",
      size: "small",
      beforeShow: function beforeShow() {
        formikProps.resetForm({});
      },
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement("p", null, "Successfully registered!");
      }
    }), !renderAllFields && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, titleField, topInstructionsField, firstNameField, lastNameField, emailField, hasSeparateUsername && usernameField, renderAdditionalFields && renderAdditionalFields(formikProps), showPasswordFields && /*#__PURE__*/_react["default"].createElement("div", null, passwordField, repeatPasswordField, termsAndConditionsField), recaptchaField && recaptchaField, submitButton(formikProps), props.showPasswordFields && termsAndConditionsLinks, bottomInstructions && bottomInstructionsField), renderAllFields && renderAllFields({
      formikBag: formikProps,
      defaultFields: {
        title: titleField,
        topInstructions: topInstructionsField,
        firstName: firstNameField,
        lastName: lastNameField,
        email: emailField,
        username: usernameField,
        password: passwordField,
        repeatPassword: repeatPasswordField,
        termsAndConds: termsAndConditionsField,
        submitButton: submitButton,
        termsAndCondsLinks: termsAndConditionsLinks,
        bottomInstructions: bottomInstructionsField,
        recaptchaField: recaptchaField
      }
    }));
  });
};
RegisterForm.propTypes = {
  title: _propTypes["default"].string,
  topInstructions: _propTypes["default"].string,
  bottomInstructions: _propTypes["default"].string,
  buttonText: _propTypes["default"].string,
  validateAdditionalFields: _propTypes["default"].func,
  renderAdditionalFields: _propTypes["default"].func,
  renderAllFields: _propTypes["default"].func,
  onRegisterSubmit: _propTypes["default"].func,
  onRegisterSuccess: _propTypes["default"].func,
  setMfaProps: _propTypes["default"].func,
  group: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  initialValues: _propTypes["default"].object,
  role: function role(props, propName, componentName) {
    // Not required if providing your own onRegisterSubmit
    if (props.onRegisterSubmit) {
      return;
    }
    if (!(typeof props[propName] === 'string' || props[propName] instanceof String)) {
      return new Error("Invalid prop \"".concat(propName, "\" supplied to ").concat(componentName, ". PropType must be string."));
    }
  },
  showPasswordFields: _propTypes["default"].bool,
  hasSeparateUsername: _propTypes["default"].bool,
  emailLabel: _propTypes["default"].string,
  isRecaptchaRequired: _propTypes["default"].bool
};
RegisterForm.defaultProps = {
  hasSeparateUsername: false,
  showPasswordFields: false
};
var _default = exports["default"] = RegisterForm;